import { CONFIG } from '../../config';
import type { GUIGameState } from '../../types/game-types';
import { roundTo } from '@game-libs/exc-libs/src/helpers';
import { useCurrencyStore } from '../zustand/useCurrencyStore';
import { useUpgradesStore } from '../zustand/useUpgradesStore';

export const generateGoldFromClickReducer = (state: GUIGameState, damageTaken: number) => {
  const upgrades = useUpgradesStore.getState().upgrades;
  const goldGeneratedByDamage = damageTaken * CONFIG.game.goldPerDamage * upgrades.click.moneyCursor.multiplier;

  const currency = useCurrencyStore.getState();
  const nextGoldTotal = roundTo(currency.gold + goldGeneratedByDamage, 2);
  useCurrencyStore.getState().setGold(nextGoldTotal);

  return state;
};
